var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ts-card',[_c('div',{staticClass:"form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"},[_c('h4',{staticClass:"ts-text-sm"},[_vm._v(_vm._s(_vm.$t('question.example')))]),_c('ts-modal-close-button')],1),_c('ts-card-wrapper',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({
        src: _vm.image,
        error: _vm.image,
        loading: require('@/assets/Rolling-1s-200px_2.svg')
      }),expression:"{\n        src: image,\n        error: image,\n        loading: require('@/assets/Rolling-1s-200px_2.svg')\n      }"}],staticClass:"ts-object-cove ts-m-auto",attrs:{"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }